<template>
  <div class="flex items-center">
    <template v-for="data in params.value">
      <div :key="data.id">
        <li>data.title</li>
        <br/>
      </div>
    </template>
    <!-- <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link> -->
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {

    url () {
      return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
